import { createSelector } from "@reduxjs/toolkit";

import {
  getDesignerNodeDataByIdSelector,
  getNodeSlotIdSelector,
  nodeIdParamSelector,
} from "@skilitics/nautilus-core-designer-data";

import { buildDesignerNodeSelector, getManifestSelector } from "../../state/contextualSelectors/index.ts";
import { resolveActiveNodesCreate } from "../querying/index.ts";

export const resolveActiveNodesSelector = createSelector(
  [getManifestSelector, getNodeSlotIdSelector, buildDesignerNodeSelector, getDesignerNodeDataByIdSelector],
  (getManifest, getSlotId, buildDesignerNode, getNodeById) =>
    resolveActiveNodesCreate({ getManifest, getSlotId, buildDesignerNode, getNodeById }),
);

export const inScopeNodesSelector = createSelector(
  resolveActiveNodesSelector,
  nodeIdParamSelector,
  (resolveActiveNodes, nodeId) => resolveActiveNodes(nodeId),
);

export const inScopeModuleNodeSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.find(({ typeId }) => typeId === "module"),
);

export const inScopeVariableNodesSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.filter(({ role }) => role === "variable"),
);

export const inScopeVariablesNodesSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.filter(({ typeId }) => typeId === "variables"),
);

export const inScopeServiceNodesSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.filter(({ role }) => role === "service"),
);

export const inScopeServicesNodesSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.filter(({ typeId }) => typeId === "services"),
);

export const inScopeTopicNodesSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.filter(({ typeId }) => typeId === "topic"),
);

export const inScopeTopicsNodesSelector = createSelector([inScopeNodesSelector], (inScopeNodes) =>
  inScopeNodes.filter(({ typeId }) => typeId === "topics"),
);
